import { useEffect, useState } from 'react';
import { db } from "../lib/firebaseConfig";
import { setDoc, doc } from "firebase/firestore";

export async function saveScrapedData(userId, data, websiteUrl) {
    const ref = doc(db, "AISettings", userId);
    await setDoc(ref, { scrapedData: data, websiteUrl: websiteUrl });
    console.log('Data have been sent to firebase');
  }
  
  const useScrapeSite = () => {
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(false);
  
    const scrapeSite = async (siteUrl) => {
      setLoading(true);
  
      try {
        const response = await fetch(`https://luna-ai-85d5ada812f1.herokuapp.com/scrape?url=${encodeURIComponent(siteUrl)}`);
        if (response.ok) {
          const data = await response.text();
          return data; // Return the fetched data
        } else {
          console.error('Error scraping site:', response.statusText);
        }
      } catch (error) {
        console.error('Error scraping site:', error);
      } finally {
        setLoading(false);
      }
  
      return null; // Scraping failed
    };
  
    return { content, loading, scrapeSite };
  };
  
  export default useScrapeSite;
  
